import { NavigationLink } from '../types/navigationLink';
import siteContent from '../content/siteContent';

export const ROUTE_URLS = {
  home: '/',
  ourBuilds: '/our-builds',
  faqs: '/faqs',
  sayHello: '/say-hello',
  formSuccess: '/form-success',
  notFound: '/404',
} as const;

export const SECTION_IDS = {
  home: {
    hero: 'hero',
    workshop: 'workshop',
    featuredBuild: 'featured-build',
    process: 'process',
    finalCta: 'final-cta',
  },
  ourBuilds: {
    intro: 'intro',
    gallery: 'gallery',
    projectHeader: 'project-header',
    projectBody: 'project-body',
    timeline: 'timeline',
    testimonial: 'testimonial',
    cta: 'cta',
  },
  faqs: {
    header: 'header',
    questions: 'questions',
    final: 'final-cta',
  },
  sayHello: {
    hero: 'hero',
    contact: 'contact',
    reach: 'reach',
    final: 'final',
  },
  utility: {
    formSuccess: 'form-success',
    notFound: 'not-found',
  },
} as const;

export const ANCHOR_URLS = {
  hero: ROUTE_URLS.home + '#' + SECTION_IDS.home.hero,
  workshop: ROUTE_URLS.home + '#' + SECTION_IDS.home.workshop,
  featuredBuild: ROUTE_URLS.home + '#' + SECTION_IDS.home.featuredBuild,
  process: ROUTE_URLS.home + '#' + SECTION_IDS.home.process,
  finalCta: ROUTE_URLS.home + '#' + SECTION_IDS.home.finalCta,
  ourBuildsIntro: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.intro,
  ourBuildsFeatured: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.gallery,
  ourBuildsProjectHeader: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.projectHeader,
  ourBuildsProjectBody: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.projectBody,
  ourBuildsTimeline: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.timeline,
  ourBuildsTestimonial: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.testimonial,
  ourBuildsCta: ROUTE_URLS.ourBuilds + '#' + SECTION_IDS.ourBuilds.cta,
  faqsHeader: ROUTE_URLS.faqs + '#' + SECTION_IDS.faqs.header,
  faqsQuestions: ROUTE_URLS.faqs + '#' + SECTION_IDS.faqs.questions,
  faqsFinal: ROUTE_URLS.faqs + '#' + SECTION_IDS.faqs.final,
  sayHelloHero: ROUTE_URLS.sayHello + '#' + SECTION_IDS.sayHello.hero,
  sayHelloContact: ROUTE_URLS.sayHello + '#' + SECTION_IDS.sayHello.contact,
  sayHelloReach: ROUTE_URLS.sayHello + '#' + SECTION_IDS.sayHello.reach,
  sayHelloFinal: ROUTE_URLS.sayHello + '#' + SECTION_IDS.sayHello.final,
  formSuccess: ROUTE_URLS.formSuccess + '#' + SECTION_IDS.utility.formSuccess,
  notFound: ROUTE_URLS.notFound + '#' + SECTION_IDS.utility.notFound,
} as const;

export const EXTERNAL_URLS = {
  instagram: siteContent.ctas.instagram.href,
  email: siteContent.ctas.email.href,
  location: siteContent.contact.methods.find((method) => method.id === 'location')?.href || '',
} as const;

export const HEADER_NAV_LINKS: NavigationLink[] = [
  { label: 'Home', to: ROUTE_URLS.home },
  { label: 'Our Builds', to: ROUTE_URLS.ourBuilds },
  { label: 'FAQs', to: ROUTE_URLS.faqs },
];

export const HEADER_CTA_LINK: NavigationLink = {
  label: siteContent.ctas.sayHello.label,
  to: siteContent.ctas.sayHello.href,
  ariaLabel: siteContent.ctas.sayHello.ariaLabel,
};

export const SOCIAL_LINKS: NavigationLink[] = [
  {
    label: 'Instagram',
    to: EXTERNAL_URLS.instagram,
    ariaLabel: siteContent.ctas.instagram.ariaLabel,
    iconName: 'FaInstagram',
    iconColour: 'instagram',
    iconPosition: 'icon-only',
    target: '_blank',
    rel: 'noopener noreferrer',
    showExternalLinkArrowIcon: false,
  },
];

export const FOOTER_QUICK_LINKS: NavigationLink[] = [
  { label: 'Home', to: ROUTE_URLS.home },
  { label: 'Our Builds', to: ROUTE_URLS.ourBuilds },
  { label: 'FAQs', to: ROUTE_URLS.faqs },
  { label: 'Say Hello', to: ROUTE_URLS.sayHello },
];
